import Vue from 'vue';
import VueRangeSlider from 'vue-range-component-fixed';

Vue.component('VueRange', VueRangeSlider);
